import { LoaderSreen } from "../../../../../common/components/molecule/Loader/Loader";
import Pagination from "../../../../../common/components/organisme/Pagination/Pagination";
import useNavigationApp from "../../../../../navigation/useNavigationApp";
import { dateConverter } from "../../../../../utils/dateConverter";
import {
  Filter,
  OrderByType,
} from "../../../../../utils/genericAPI/useGenericAPI";
import SingleClient from "../../../../clients/components/SingleClient";
import ErrorScreenApp from "../../../../errorHandler/components/ErrorScreenApp/ErrorScreenApp";
import SingleOrganization from "../../../../organization/components/SingleOrganization";
import { usePaygo } from "../../../hooks/usePaygo";
import { Paygo } from "../../../types/paygo.types";
import PaygoListView from "./PaygoListView/PaygoListView";

export default function PaygoListPresenter({
  pageSize = 8,
  orderBy = "-paygo_created_at",
  preFilter,
}: {
  pageSize?: number;
  orderBy?: OrderByType<Paygo>;
  preFilter?: Filter<Partial<Paygo>>;
}) {
  const {
    allPaygoQuery: { data, isError, isLoading, setPage, error },
  } = usePaygo({ pageSize, orderBy, preFilter: preFilter });

  const { goToSinglePayGo } = useNavigationApp();
  return (
    <>
      {isLoading && <LoaderSreen heigth={"200px"} />}
      {isError && <ErrorScreenApp axiosError={error} />}
      {!isLoading && !isError && (
        <PaygoListView
          content={
            data?.data?.map((item) => ({
              id: item.paygo_id,
              createAt: dateConverter(item.paygo_created_at, {withTime: true}),
              kWhAmount: item.paygo_kwh.toFixed(2),
              organizationRender: () => (
                <SingleOrganization.Name
                  organizationId={item.organization_id}
                />
              ),
              code: item.paygo_token,
              onClick: () => goToSinglePayGo(item.paygo_id, { keepURL: true }),
              amountPrice: item.paygo_payment_amount,
              currency: item.paygo_currency,
              forRender: () => (
                <>
                  <span style={{ fontSize: "0.9rem" }}>
                    {item.paygo_client !== "" ? (
                      <>
                        <SingleClient.Info
                          id={item.paygo_client}
                          info="client_firstname"
                          emptyText={item.paygo_client_phone_number}
                        />{" "}
                        <SingleClient.Info
                          id={item.paygo_client}
                          info="client_lastname"
                          emptyText=""
                        />
                      </>
                    ) : (
                      item.paygo_client_phone_number
                    )}
                  </span>
                </>
              ),
            })) || []
          }
          nbFound={data?.pagination?.total_count}
        />
      )}
      <Pagination
        centered
        setCurrentPage={setPage}
        currentPage={data?.pagination?.current_page}
        lastPage={data?.pagination.total_pages}
        nbBtnToDisplay={5}
      />
    </>
  );
}
